import React, { useState }  from 'react';
import { injectIntl } from 'react-intl';
import { useMutation } from '@apollo/react-hooks';
import Button from '@uniiverse/library/components/button';
import Config from 'config';
import { addons } from './locale';
import style from './index-module.css';
import CREATE_ADDON_MUTATION from '../create-add-on.gql';

const CUSTOM_TAX_SELECTION_ID = 'new_custom_tax';
const PLACEHOLDER_TAX_RATE_ID = 'placeholder_tax_rate';
const EMPTY_TAX_RATE_ID = 'empty_tax_rate';
const FILTER_TAX_IDS = [CUSTOM_TAX_SELECTION_ID, PLACEHOLDER_TAX_RATE_ID, EMPTY_TAX_RATE_ID];

const filterTaxIds = (taxIds) => taxIds.filter((id) => !FILTER_TAX_IDS.includes(id));

const CreateButtons = injectIntl((props) => {
  const [disabled, setDisabled] = useState(false);
  const [createAddOnMutation] = useMutation(CREATE_ADDON_MUTATION);

  const handleClick = async (isDraft = false) => {
    const {
      validateForm,
      shapeNewRates,
      shapeNewImages,
      prepareAddOnCustomization,
      postPurchaseMessage,
      sanitizeEditorText,
      description,
      prepareAvailabilityRules,
    } = props;

    if (validateForm()) {
      setDisabled(true);
      const newRates = shapeNewRates(props.rates, props.name, isDraft);
      const newImages = shapeNewImages(props.images);
      const newAddOn = {
        taxIds: filterTaxIds(props.taxes.map((tax) => tax.id)),
        hostId: props.hostId,
        eventIds: props.listingIds,
        attributes: {
          name: props.name,
          description: sanitizeEditorText(description),
          currency: props.currency,
          rates: newRates,
          images: newImages,
          postPurchaseMessage: sanitizeEditorText(postPurchaseMessage),
          suppressQrCode: props.hideQRCode
        },
        addOnCustomization: prepareAddOnCustomization(),
        availabilityRules: prepareAvailabilityRules()
      };

      if (!isDraft) {
        newAddOn.attributes = {...newAddOn.attributes, hostPaysCommission: JSON.parse(props.hostPaysCommission)};
      }

      await createAddOnMutation({ variables: { addOn: newAddOn }}).then(({ data }) => {
        const { errors } = data.createAddOn;
        if (errors && errors.length > 0) {
          props.renderErrorMessages(errors);
        }
        else {
          window.location.href = `${Config.api.host}/dashboard/add-ons`;
        }
      });
    }
  }

  const renderCancelRow = () => {
    if (props.renderCancel) {
      return <div className={style.cancelActions}>
        {props.renderCancel()}
        <Button
          className={`${style.saveAsDraftButton} ui fluid inverted primary button`}
          onClick={() => {
            handleClick(true);
          }}
          disabled={disabled}
        >
          {props.intl.formatMessage(addons.saveAsDraft)}
        </Button>
      </div>
    }

    return <Button
      className={`${style.saveAsDraftButton} ui fluid inverted primary button`}
      onClick={() => {
        handleClick(true);
      }}
      disabled={disabled}
    >
      {props.intl.formatMessage(addons.saveAsDraft)}
    </Button>;
  }

  return (
    <div className={style.createAddonActions}>
      <Button
        className={style.createAddOnButton}
        type='primary'
        onClick={() => {
          handleClick();
        }}
        disabled={disabled}
      >
        {props.intl.formatMessage(addons.createAddon)}
      </Button>
      {renderCancelRow()}
    </div>
  )
});

export default CreateButtons;
